import { combineReducers } from 'redux-immutablejs';

import codefileReducer from './codefile';
import configReducer from './config';
import globalReducer from './global';
import eventformReducer from './eventform';
import eventReducer from './event';
import rolesReducer from './roles';
import searchReducer from './search';

export default combineReducers({
  codefile: codefileReducer,
  config: configReducer,
  global: globalReducer,
  event: eventReducer,
  eventform: eventformReducer,
  roles: rolesReducer,
  search: searchReducer,
});
